import COLORS from '@styles/colors/themes/beam/beam2';

export function makeColorVars() {
  const colorEntries = Object.entries(COLORS);

  const variablesFormatted = colorEntries.map(entry => {
    const [colorName, shades] = entry;
    const shadeEntries = Object.entries(shades);

    const variables = shadeEntries.map(shadeEntry => {
      const [shade, value] = shadeEntry;
      return colorVariable(colorName, shade, value);
    });
    const formatted = variables.join('\n');
    return formatted;
  });

  return variablesFormatted.join('\n');
}
function colorVariable(colorName: string, shade: string, value: string) {
  return `--beam-color-${colorName}-${shade}: ${value};`;
}
